import { Component, OnInit } from "@angular/core";
import { IConetionConfiguration } from "../core/interfaces/IConetionConfiguration";
import { TableauService } from "../core/services/tableau.service";


@Component({
    selector: 'dv-tableau',
    templateUrl: './dv-tableau.component.html',
    styleUrls: ['./dv-tableau.component.scss']
})

export class TableauComponent implements OnInit{
    tableauConfigurations: any[] = [];
    tableauConfiguration: any = null;
    reportConfiguration: any = null;
    isConexion: boolean = true;
    currentItemSelected: string = '';
    currentItemReportSelected: string = '';
    anyItemSelected: boolean = false;
    isLoading: boolean = false;

    constructor(private tableauService: TableauService) {}
    
    ngOnInit() {
        this.loadData();
    }

    loadData() {
        this.tableauService.getTableuConfigurations().subscribe((result: any) => {
            this.tableauConfigurations = result;
        });
    }

    isSelected(id: string): boolean {
        if (this.isConexion)
            return this.currentItemSelected === id ? true : false;
        else
            return this.currentItemReportSelected === id ? true : false;
    }

    clickItem(configurationConexion: IConetionConfiguration) {
        this.isConexion = true;
        if (this.currentItemSelected !== configurationConexion.Id)
        {
          this.currentItemSelected = configurationConexion.Id;
          this.tableauConfiguration = configurationConexion;
          this.anyItemSelected = true;
          return;
        }
        if (this.currentItemSelected === configurationConexion.Id)
        {
          this.resetValues();
          this.anyItemSelected = true;
        }
    }

    collapseItems(collapse: boolean, configurationConexion: string) {
        if (collapse) {
            this.resetValues();
            this.currentItemSelected = '';
          } else
          {
            this.currentItemSelected = configurationConexion;
            this.tableauConfiguration = this.tableauConfigurations.find(power => power.Id === this.currentItemSelected);
          }
    }


    resetValues () {
        this.currentItemReportSelected = '';
        this.reportConfiguration = null;
        this.anyItemSelected = false;
    }

    isOpen(id: string): boolean {
        return this.currentItemSelected === id ? true : false;
    }

    
  clickItemReport(configurationReport: any) {
    this.isConexion = false;
    if (this.currentItemReportSelected !== configurationReport.Id)
    {
      this.currentItemReportSelected = configurationReport.Id;
      this.reportConfiguration = configurationReport;
      this.anyItemSelected = true;
      return;
    }
    if (this.currentItemReportSelected === configurationReport.Id)
      this.resetValues();
  }
}